import styled from 'styled-components';

export const StyledTooltip = styled.div`
  z-index: 1;
  font-size: 9.5px;
  line-height: 12px;
  box-shadow: ${(p) => p.theme.shadows.all};
  padding: 4px ${(p) => p.theme.space[2]};
  border-radius: ${(p) => p.theme.radii.pill};
  background-color: ${(p) => p.theme.alias.bg};

  &[aria-hidden='true'] {
    opacity: 0;
    visibility: hidden;
  }
`;
